import {
	CalendarOutlined,
	ClockCircleOutlined,
	CompassOutlined,
} from "@ant-design/icons";
import { CgHeadset } from "react-icons/cg";
import { LabelButtonStyled } from "./styles";
import { Spacer } from "../common/Spacer";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Text } = Typography;

const iconStyles = { color: "#000", fontSize: 16, marginRight: 5 };

export const LabelButton = ({ type, label, onClick, desktop }) => {
	const { t } = useTranslation("booking");

	const configObj = {
		attention: {
			icon: <CgHeadset style={iconStyles} />,
			title: t("attentionType"),
		},
		date: {
			icon: <CalendarOutlined style={iconStyles} />,
			title: t("date"),
		},
		time: {
			icon: <ClockCircleOutlined style={iconStyles} />,
			title: t("hour"),
		},
		address: {
			icon: <CompassOutlined style={iconStyles} />,
			title: t("address"),
		},
	};

	return (
		<LabelButtonStyled desktop={desktop} onClick={() => onClick(type)}>
			<div>{configObj[type].icon}</div>
			{desktop && <Spacer rows={0.3} />}
			{desktop && <Text>{configObj[type].title}</Text>}
			{desktop && <Spacer rows={0.3} />}
			<div>{label}</div>
		</LabelButtonStyled>
	);
};
